import React, { Component } from 'react';
import { withStyles } from 'material-ui/styles';
import { FusePageSimple } from '@fuse';

import { Button, Paper, MenuItem, Radio, Typography, Divider } from 'material-ui';
import Select from 'react-select';
import 'react-select/dist/react-select.css'
import TextField from 'material-ui/TextField';
import $ from "jquery";
import Formsy from 'formsy-react';
import Loader from "other-components/loader/loader";
import Checkbox from 'material-ui/Checkbox';
import { TextFieldFormsy, CheckboxFormsy, RadioGroupFormsy, SelectFormsy } from '@fuse';
import Icon from 'material-ui/Icon';
import IconButton from 'material-ui/IconButton';

import axios from 'axios';
import Tooltip from 'material-ui/Tooltip';
import Card, { CardActions, CardContent } from 'material-ui/Card';
import printjs from 'print-js';


import Dialog, {
    DialogActions,
    DialogContent,
    DialogTitle,
} from 'material-ui/Dialog';
import ReactTable from "react-table";
import DayPickerInput from 'react-day-picker/DayPickerInput';

import { withAlert } from 'react-alert';
import { Route, Redirect } from 'react-router'

const styles = theme => ({
    layoutRoot: {},

});

class InterAccTransfer extends Component {

    state = {
        value: 0
    };

    constructor(props) {
        super(props);

        this.state = {
            currentDate: null,
            referenceNumber: '',
            transactionCode: '',
            amount: 0,
            amountReceived: 0,
            description: '',

            loadLedgerAccounts: [],
            selectedLedgerAccount: '',
            selectedLedgerAccountName: '',
            selectedLedgerAccountReceived: '',
            transactionDate: null,

            closeDate: null,

            selectedPaymentStatus: 0,
            loadPayStatus: [
                { value: "processing", label: "Processing" },
                { value: "completed", label: "Completed" }],


        };

        this.loadCurrentDate();
        this.loadLedgerAccounts();

        this.handleTransactionDateChange = this.handleTransactionDateChange.bind(this);
        this.handleCloseDateChange = this.handleCloseDateChange.bind(this);
        this.loadPaymentStatus = this.loadPaymentStatus.bind(this);

        this.setLedgerAccReceivedIntoField = this.setLedgerAccReceivedIntoField.bind(this);
        this.setLedgerAccIntoField = this.setLedgerAccIntoField.bind(this);
    }

    // get current date
    loadCurrentDate() {
        var date = new Date();
        var formatedDate = ((date.getMonth() + 1) + '/' + date.getDate() + '/' + date.getFullYear()).toString();
        this.setState({ currentDate: formatedDate });
    }

    // set transaction date
    handleTransactionDateChange(date) {
        console.log('changeDate', date);
        this.setState({
            transactionDate: date
        });
    }

    // set payment closr date
    handleCloseDateChange(date) {

        var dateCloseDate = new Date(date);
        var today = new Date();

        today.setHours(0);
        today.setMinutes(0);
        today.setSeconds(0);
        console.log(today);

        dateCloseDate.setHours(0);
        dateCloseDate.setMinutes(0);
        dateCloseDate.setSeconds(0);
        console.log(dateCloseDate);

        if ((dateCloseDate > today) || (dateCloseDate.toDateString() === today.toDateString())) {

            console.log("feture date");
            this.setState({ closeDate: date });
        } else {
            console.log("Date pass date");
            this.setState({ closeDate: '' });
            this.props.alert.error("Cannot proceed this date");

        }

    }

    handleTextBoxChange = name => event => {
        var fromAmount = this.state.amount;

        if ('amount' == [name][0]) {
            this.setState({ amountReceived: event.target.value });
            this.setState({ [name]: event.target.value });
        } else {
            this.setState({ [name]: event.target.value });
        }

    };


    // load ledger accounts 
    loadLedgerAccounts() {
        this.setState({ loading: true });

        var loadLedgerAccounts = [];

        axios.get(window.accountServer + '/ledgerAccount/getLedgerAccountDetails')
            .then(response => {

                if (response.data.success) {
                    var ledgerAccObj = response.data.ledgerAccountDetails;

                    console.log("ledgerAccountDetails ", ledgerAccObj);

                    for (var i = 0; i < ledgerAccObj.length; i++) {

                        loadLedgerAccounts.push({
                            value: ledgerAccObj[i].ID_LEDGER_ACCOUNT,
                            label: ledgerAccObj[i].NAME
                        });
                    }
                } else {
                    console.log("No results found ledger account details");
                }

                this.setState({ loadLedgerAccounts: loadLedgerAccounts });
                this.setState({ loading: false });

            }).catch(function (error) {
                // alert(error);
                console.log("ledger detail err " + error);
                console.log("No internet connection or Internal error");
                this.setState({ loading: false });
                // alert("No internet connection or Internal error");
            });
    }

    // set ledger account received into selected field
    setLedgerAccReceivedIntoField = (selectedOption) => {
        if (null == selectedOption) {
            this.setState({ selectedLedgerAccountReceived: '' });
        } else {
            this.setState({ selectedLedgerAccountReceived: selectedOption.value });
        }
    }

    // set ledger account into selected field
    setLedgerAccIntoField = (selectedOption) => {
        if (null == selectedOption) {
            this.setState({ selectedLedgerAccount: '' });
        } else {
            this.setState({ selectedLedgerAccount: selectedOption.value });
        }
    }
    // load payment status
    loadPaymentStatus = (selectedOption) => {
        var selectedPaymentStatus = selectedOption.value;
        this.setState({ selectedPaymentStatus: selectedPaymentStatus });
    }

    // save Inter account transfer payment
    saveInterAccountTransferPayment() {

        console.log("transaction No: ",this.state.transactionCode)
        console.log("Reference No: ",this.state.referenceNumber)
        console.log("transaction date: ",this.state.transactionDate)
        console.log("payment close date: ",this.state.closeDate)
        console.log("selected ledger account: ",this.state.selectedLedgerAccount)
        console.log("selected ledger account name: ",this.state.selectedLedgerAccountName)
        console.log("selected ledger account recieved",this.state.selectedLedgerAccountReceived)
        console.log("payment close date: ",this.state.amount)
        console.log("payment close date: ",this.state.amountReceived)
        console.log("payment close date: ",this.state.description)


        var ledgerAccountNo = {
            account_no:this.state.selectedLedgerAccount,
            account_no_recieved : this.state.selectedLedgerAccountReceived
        }


        
        
        
                

        this.setState({ loading: true });


        var closeDate = new Date(this.state.closeDate);
        var today = new Date();
        today.setHours(0);
        today.setMinutes(0);
        today.setSeconds(0);

        if (null == closeDate || undefined == closeDate || '' == closeDate) {

            this.props.alert.error("Date Selection error");
            this.setState({ loading: false });
        } else {
            console.log(closeDate);
            console.log(today);

            if (closeDate.toDateString() === today.toDateString()) {

                console.log("same Date");
                this.saveInterAccountTransferPaymentPermatly();

            } else {

                if (closeDate < today || '' == closeDate) {

                    console.log("Selected date is in the past");
                    this.props.alert.error("This date was pass cannot add this date !");
                    this.setState({ loading: false });

                } else if (closeDate > today) {

                    this.saveInterAccountTransferPaymentTempory();
                    console.log("Selected date is NOT in the past");

                }
            }
        }


        axios.post(window.accountServer + '/interAccountTransfer/getLedgerDataForInterAccountTransferReport',ledgerAccountNo)
        .then(response =>{
            console.log('getLedgerDataForInterAccountTransferReport', response)
            if (response.data.success = true) {
                console.log("done..");
            }


            var account_name = "";
            var account_name_recieved = "";


            for(let i=0;i<response.data.accountLedgerDetails.length;i++){
                if(ledgerAccountNo.account_no==response.data.accountLedgerDetails[i].ID_LEDGER_ACCOUNT){
                    account_name = response.data.accountLedgerDetails[i].NAME
                }
    
                if(ledgerAccountNo.account_no_recieved==response.data.accountLedgerDetails[i].ID_LEDGER_ACCOUNT){
                    account_name_recieved = response.data.accountLedgerDetails[i].NAME
                }

            }
           

            console.log("account Name: "+account_name);
            console.log("account name recieved: "+account_name_recieved);


            var interAccountTransferReportDetails  = {
                transaction_no : this.state.transactionCode,
                reference_no : this.state.referenceNumber,
                transaction_date : this.state.transactionDate,
                payment_close_date : this.state.closeDate,
                selected_account_no : this.state.selectedLedgerAccount,
                selected_account_no_recieved : this.state.selectedLedgerAccountReceived,
                des : this.state.description,
                out_flow : this.state.amount,
                in_flow :this.state.amountReceived,
                total_amount: this.state.totalAmount,
                account_name:account_name,
                account_name_recieved:account_name_recieved
    
            }



        axios.post(window.reportServer+'/interAccountTransferReport/get/interAccountTransferReport', interAccountTransferReportDetails)
        //axios.post(window.accountServer + '/transactionLedger/bulkInsert ', transactionObj)
        .then(response => {
            console.log(response)
            if (response.data.success == true) {

                if(this.state.selectedLedgerAccount != this.state.selectedLedgerAccountReceived){
                    var address = response.data.path;
                    address = window.reportServer + "/" + address;
                    // address = "http://localhost:2008/" + address;
    
                    printjs({ printable: address, type: 'pdf', showModal: true })
                    //console.log("done..");
                }
               
               
            }
            this.clearValue()
        }).catch(function (error) {
            console.log("err " + error);
            console.log("No internet connection or Internal error");
        });



        }).catch(function (error) {
                            console.log("err " + error);
                            console.log("No internet connection or Internal error");
        });




        


    }

    // save tempory 
    saveInterAccountTransferPaymentTempory() {

        var ledgerAccountHeaderTemp = {
            ledgerAccountId: this.state.selectedLedgerAccount,
            transactionDate: this.state.transactionDate,
            refNo: this.state.referenceNumber,
            status: this.state.selectedPaymentStatus,
            totalAmount: this.state.totalAmount,
            paymentCloseDate: this.state.closeDate
        };


        var ledgerAccountDetailArTemp = [];
        var creditObj = {
            creditLedgerAccount: this.state.selectedLedgerAccount,
            amount: this.state.amount
        };

        var debitObj = {
            debitLedgerAccount: this.state.selectedLedgerAccountReceived,
            amount: this.state.amountReceived
        };

        ledgerAccountDetailArTemp.push(creditObj);
        ledgerAccountDetailArTemp.push(debitObj);

        if (null == this.state.transactionDate || undefined == this.state.transactionDate || "" == this.state.transactionDate) {

            this.props.alert.info("Input transaction date first !");
            this.setState({ loading: false });
        } else {

            if (this.state.selectedLedgerAccount == this.state.selectedLedgerAccountReceived) {

                this.props.alert.error("Cannot transfer same account");
                this.setState({ loading: false });

            } else {
                if (0 == ledgerAccountDetailArTemp.length || null == ledgerAccountDetailArTemp || undefined == ledgerAccountDetailArTemp) {

                    this.props.alert.info("No any payment to save !");
                    this.setState({ loading: false });
                } else {

                    var interAccountPaymentObj = {
                        ledgerAccountHeader: ledgerAccountHeaderTemp,
                        ledgerAccountDetailAr: ledgerAccountDetailArTemp,
                        saveMethod: 'TEMP'
                    };

                    axios.post(window.accountServer + '/interAccountTransfer/saveInterAccountTransfer', interAccountPaymentObj)
                        // axios.post('http://localhost:5009/interAccountTransfer/saveInterAccountTransfer', interAccountPaymentObj)
                        .then(response => {
                            if (response.data.success) {

                                this.state.ledgerAccountDetailAr = [];
                                this.props.alert.success("Payment Saved Successfully");
                                this.setState({ loading: false });

                            } else {

                                this.props.alert.error("Canot Save Pyamnet !");
                                this.setState({ loading: false });
                            }

                        }).catch(function (error) {
                            // alert(error);
                            console.log("server er : ", error);
                            console.log("No internet connection or Internal error");
                            this.setState({ loading: false });
                        });
                }
            }
        }
    }

    /// save permatly 
    saveInterAccountTransferPaymentPermatly() {

        var ledgerAccountHeaderPer = {
            ledgerAccountId: this.state.selectedLedgerAccount,
            transactionDate: this.state.transactionDate,
            refNo: this.state.referenceNumber,
            status: this.state.selectedPaymentStatus,
            totalAmount: this.state.totalAmount,
            paymentCloseDate: this.state.closeDate
        };


        var ledgerAccountDetailArPer = [];
        var creditObj = {
            creditLedgerAccount: this.state.selectedLedgerAccount,
            amount: this.state.amount
        };

        var debitObj = {
            debitLedgerAccount: this.state.selectedLedgerAccountReceived,
            amount: this.state.amountReceived
        };

        ledgerAccountDetailArPer.push(creditObj);
        ledgerAccountDetailArPer.push(debitObj);

        if (null == this.state.transactionDate || undefined == this.state.transactionDate || "" == this.state.transactionDate) {

            this.props.alert.info("Input transaction date first !");
            this.setState({ loading: false });
        } else {

            if (this.state.selectedLedgerAccount == this.state.selectedLedgerAccountReceived) {

                this.props.alert.error("Cannot transfer same account");
                this.setState({ loading: false });

            } else {

                if (0 == ledgerAccountDetailArPer.length || null == ledgerAccountDetailArPer || undefined == ledgerAccountDetailArPer) {

                    this.props.alert.info("No any payment to save !");
                    this.setState({ loading: false });
                } else {

                    var interAccountPaymentObj = {
                        ledgerAccountHeader: ledgerAccountHeaderPer,
                        ledgerAccountDetailAr: ledgerAccountDetailArPer,
                        saveMethod: 'PER'
                    };

                    axios.post(window.accountServer + '/interAccountTransfer/saveInterAccountTransfer', interAccountPaymentObj)

                        .then(response => {
                            if (response.data.success) {

                                this.state.ledgerAccountDetailArPer = [];
                                this.props.alert.success("Transfered Successfully\nTransaction code is : " + response.data.id);
                                this.setState({ loading: false });

                            } else {

                                this.props.alert.error("Canot Transfer !");
                                this.setState({ loading: false });
                            }

                        }).catch(function (error) {
                            // alert(error);
                            console.log("server er : ", error);
                            console.log("No internet connection or Internal error");
                            this.setState({ loading: false });
                        });
                }
            }
        }

    }

    // clear all field
    clearAll() {
        this.setState({ currentDate: null });
        this.setState({ referenceNumber: '' });
        this.setState({ transactionCode: '' });
        this.setState({ amount: 0 });
        this.setState({ amountReceived: 0 });
        this.setState({ selectedLedgerAccount: '' });
        this.setState({ selectedLedgerAccountName: '' });
        this.setState({ selectedLedgerAccountReceived: '' });
        this.setState({ transactionDate: '' });
        this.setState({ closeDate: '' });
        this.setState({ description: '' });
    }

    render() {

        const { classes } = this.props;
        const { value } = this.state;
        if (this.state.loading) {
            return (<Loader />);
        }
        else {
            return (
                <FusePageSimple
                    classes={{
                        root: classes.layoutRoot
                    }}

                    contentToolbar={
                        <div className="px-24"><h2 className="subtitle-color">Inter Account Transfer</h2></div>
                    }
                    content={
                        <div className="p-24 {classes.root}">
                            <div className="p-24 {classes.root} ">

                                <div className="flex flex-wrap -mx-3 mb-6">

                                    <div className="w-1/4 inline-block">
                                        <p>Transaction Date</p>
                                        <DayPickerInput
                                            className="bg-orange"
                                            onDayChange={this.handleTransactionDateChange}
                                            selectedDays={this.state.transactionDate}
                                            value={this.state.transactionDate}
                                            onChange={this.handleTextBoxChange('transactionDate')}
                                        />
                                    </div>

                                    <TextField
                                        className="w-1/4 mr-16"
                                        type="text"
                                        name="transactionCode"
                                        label="Transaction Code"
                                        value={this.state.transactionCode}
                                        onChange={this.handleTextBoxChange('transactionCode')}
                                    />

                                    <TextField
                                        className="w-1/4 "
                                        type="text"
                                        id="refNumber"
                                        name="refNumber"
                                        label="Ref-No"
                                        value={this.state.referenceNumber}
                                        onChange={this.handleTextBoxChange('referenceNumber')}
                                    />

                                </div>
                                <Divider className="md:mt-16 sm:mt-8 inter-acco-margin"/>
                                <div className="flex flex-wrap -mx-3 mb-6">

                                    <div className="w-1/4 inline-block pr-24">
                                        <p>Paid From</p>
                                        <Select
                                            name="form-field-name"
                                            placeholder="Select Ledger Account"
                                            value={this.state.selectedLedgerAccount}
                                            onChange={this.setLedgerAccIntoField}
                                            options={this.state.loadLedgerAccounts}
                                        />
                                    </div>
                                    <TextField
                                        className="w-1/4 mr-16"
                                        type="number"
                                        name="amount"
                                        label="Amount"
                                        value={this.state.amount}
                                        onChange={this.handleTextBoxChange('amount')}
                                    />

                                    {/* <div className="w-full md:w-1/4 inline-block pr-24">
                                        <p>Payment Status</p>
                                        <Select
                                            name="form-field-name"
                                            placeholder="Select Status"
                                            value={this.state.selectedPaymentStatus}
                                            onChange={this.loadPaymentStatus}
                                            options={this.state.loadPayStatus}
                                        />
                                    </div> */}

                                    <div className="w-1/4 inline-block pr-24">
                                        <p>Payment Close Date</p>
                                        <DayPickerInput
                                            className="bg-orange"
                                            onDayChange={this.handleCloseDateChange}
                                            selectedDays={this.state.closeDate}
                                            value={this.state.closeDate}
                                            onChange={this.handleTextBoxChange('closeDate')}
                                        />
                                    </div>
                                </div>

                                <div className="flex flex-wrap -mx-3 mb-6 inter-account-padding">

                                    <div className="w-1/4 inline-block pr-24">
                                        <p>Recieved To</p>
                                        <Select
                                            name="form-field-name"
                                            placeholder="Select Ledger Account"
                                            value={this.state.selectedLedgerAccountReceived}
                                            onChange={this.setLedgerAccReceivedIntoField}
                                            options={this.state.loadLedgerAccounts}
                                        />
                                    </div>

                                    <TextField
                                        className="w-1/4 mr-16"
                                        type="number"
                                        name="amountReceived"
                                        label="Amount"
                                        value={this.state.amountReceived}
                                        onChange={this.handleTextBoxChange('amountReceived')}
                                        disabled
                                    />

                                    <TextField
                                        className="w-2/4 "
                                        type="text"
                                        name="description"
                                        label="Description"
                                        value={this.state.description}
                                        onChange={this.handleTextBoxChange('description')}
                                    />
                                </div>

                                <Divider className="md:mt-16 sm:mt-8" />
                            </div>
                            <div className="w-full md:w-2/3"></div>

                            <div className="w-full md:w-1/3 float-right mb-16">
                                <Button type="button" onClick={(ev) => this.saveInterAccountTransferPayment()} variant="raised" size="small" color="secondary" className="{classes.button} w-full md:w-1/3 md:h-24 mt-16 pr-24 -ml-24 mr-8">
                                    Save
                                </Button>

                                <Button type="button" onClick={(ev) => this.clearAll()} variant="raised" size="small" className="{classes.button} w-full md:w-1/3 md:h-24 mt-16 pr-24 mr-8">
                                    Clear
                                </Button>

                                <Button type="button" variant="raised" size="small" color="primary" className="{classes.button} w-full md:w-1/3 md:h-24 mt-16 pr-24">
                                    Help
                                </Button>
                            </div>
                        </div>
                    }
                />
            );
        }
    }

}


export default withStyles(styles, { withTheme: true })(withAlert(InterAccTransfer));


// WEBPACK FOOTER //
// ./src/main/content/accounting/interAccTransfer/InterAccTransfer.js